import { Button, Box, Flex, Text, HStack } from '@chakra-ui/react';
import { Image } from '@chakra-ui/react/image';
import { LuMoon, LuSun } from 'react-icons/lu';
import { Link as RouterLink } from 'react-router';
import logo from '../../assets/logo.png';
import useGameStore from '@/store';
import { useColorMode } from '../common/color-mode';
import SearchBox from './SearchBox';
import LanguageToggle from './LanguageToggle';

const NavBar = () => {
	const { colorMode, toggleColorMode } = useColorMode();
	const resetFilters = useGameStore((s) => s.resetFilters);

	return (
		<Box
			as="header"
			position="sticky"
			top={0}
			zIndex={50}
			backdropFilter="blur(16px)"
			bg={{ _light: 'rgba(255,255,255,0.9)', _dark: 'rgba(11,11,15,0.9)' }}
			borderBottomWidth="1px"
			borderColor="border"
		>
			<Flex
				align="center"
				gap={{ base: 2, md: 6 }}
				px={{ base: 4, md: 8 }}
				py={3}
				maxW="1600px"
				mx="auto"
			>
				<RouterLink
					to="/"
					onClick={() => resetFilters()}
					style={{ textDecoration: 'none', color: 'inherit', flexShrink: 0 }}
				>
					<HStack gap={2.5} cursor="pointer">
						<Image
							src={logo}
							h={{ base: '36px', md: '42px' }}
							w="auto"
							objectFit="contain"
							alt="GameHub"
						/>
						<Text
							fontWeight="800"
							fontSize={{ base: 'md', md: 'lg' }}
							letterSpacing="tight"
							display={{ base: 'none', sm: 'block' }}
						>
							GameHub
						</Text>
					</HStack>
				</RouterLink>

				<Box flex={1} maxW="560px" mx="auto">
					<SearchBox />
				</Box>

				<HStack gap={0} flexShrink={0}>
					<LanguageToggle />
					<Button
						onClick={toggleColorMode}
						size="sm"
						variant="ghost"
						rounded="full"
						aria-label="Toggle color mode"
					>
						{colorMode === 'dark' ? <LuSun size={18} /> : <LuMoon size={18} />}
					</Button>
				</HStack>
			</Flex>
		</Box>
	);
};

export default NavBar;
